import { useMemo } from 'react';
export const useSeatByIdMap = (seatLayout) => {
    return useMemo(() => {
        const seatByIdMap = new Map();
        seatLayout.areas.forEach(area => {
            area.rows.forEach(row => {
                row.seats.forEach(seat => seatByIdMap.set(seat.id, seat));
            });
        });
        return seatByIdMap;
    }, [seatLayout]);
};
//# sourceMappingURL=use-seat-by-id-map.js.map